<script setup lang="ts">
    import type { HTMLAttributes } from 'vue';
    import { cn } from '@/lib/utils';

    const props = defineProps<{
        class?: HTMLAttributes['class'];
        style?: HTMLAttributes['style'];
    }>();
</script>

<template>
    <tr
        data-slot="table-row"
        :style="props.style"
        :class="
            cn(
                'data-[state=selected]:[&_td]:bg-table-selected-row transition-colors [&_td]:inset-shadow-[0_-1px_0_0_var(--table-border)] last:[&_td]:inset-shadow-none',
                // 'hover:[&_td]:bg-faded',
                props.class,
            )
        "
    >
        <slot />
    </tr>
</template>
